<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0008 13.4849L17.5059 18.99L18.4958 18L12.9908 12.495L18.4958 6.98995L17.5059 6L12.0008 11.505L6.49581 6L5.50586 6.98995L11.0109 12.495L5.50586 18L6.49581 18.99L12.0008 13.4849Z" fill="currentColor" />
</svg>
